export interface ForbiddenInfo {
  code: string;
  message: string;
}

// Último 403 interceptado en lib/api.ts — leído por pages/SinAcceso.tsx.
// Módulo en memoria (no React state): api.ts no es un componente y la
// navegación a /sin-acceso ya recarga la pantalla que lo consume.
let lastForbidden: ForbiddenInfo | null = null;

export function setLastForbidden(info: ForbiddenInfo): void {
  lastForbidden = info;
}

export function getLastForbidden(): ForbiddenInfo | null {
  return lastForbidden;
}
